import React, { useState } from 'react';
import CRMDashboard    from './crm/CRMDashboard';
import CRMClients      from './crm/CRMClients';
import CRMContacts     from './crm/CRMContacts';
import CRMOpportunites from './crm/CRMOpportunites';
import CRMInteractions from './crm/CRMInteractions';
import CRMCampagnes    from './crm/CRMCampagnes';
import CRMRappels      from './crm/CRMRappels';

const TABS = [
  { key: 'dashboard',    label: '📊 Tableau de bord' },
  { key: 'clients',      label: '🏢 Clients / Prospects' },
  { key: 'contacts',     label: '👤 Contacts' },
  { key: 'opportunites', label: '📈 Opportunités' },
  { key: 'interactions', label: '💬 Interactions' },
  { key: 'campagnes',    label: '📣 Campagnes' },
  { key: 'rappels',      label: '♻️ Rappels recyclage' },
];

export default function CRM() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div className="crm-root">
      {/* Sous-navigation CRM */}
      <nav className="crm-subnav">
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`crm-subnav-btn${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {/* Contenu de l'onglet actif */}
      <div className="crm-content">
        {activeTab === 'dashboard'    && <CRMDashboard    onNavigate={setActiveTab} />}
        {activeTab === 'clients'      && <CRMClients />}
        {activeTab === 'contacts'     && <CRMContacts />}
        {activeTab === 'opportunites' && <CRMOpportunites />}
        {activeTab === 'interactions' && <CRMInteractions />}
        {activeTab === 'campagnes'    && <CRMCampagnes />}
        {activeTab === 'rappels'      && <CRMRappels />}
      </div>
    </div>
  );
}
